"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SectionHeader } from "fansunited-sports-ui";
import { usePlayerPageData } from "../context/PlayerPageDataContext";
import { useLabels } from "@/lib/labels/LabelsProvider";
function calculateAge(dateOfBirth: string | undefined): number | null {
  if (!dateOfBirth) return null;
  const dob = new Date(dateOfBirth);
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || monthDiff === 0 && today.getDate() < dob.getDate()) {
    age--;
  }
  return age;
}
export const PlayerInfoCard: React.FC = () => {
  const $ = _c(50);
  const {
    player,
    playerInfo
  } = usePlayerPageData();
  const labels = useLabels().playerPage.info;
  let t0;
  if ($[0] !== player.teams) {
    t0 = player.teams?.find(_temp) ?? player.teams?.[0];
    $[0] = player.teams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentTeam = t0;
  const t1 = player.birthdate || playerInfo?.dateOfBirth;
  let t2;
  if ($[2] !== t1) {
    t2 = calculateAge(t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const age = t2;
  const positions = labels.positions;
  let t3;
  if ($[4] !== player.position) {
    t3 = player.position?.toLowerCase();
    $[4] = player.position;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const positionKey = t3 as keyof typeof positions | undefined;
  const translatedPosition = positionKey && positions[positionKey] || player.position;
  let t4;
  if ($[6] !== labels.position || $[7] !== translatedPosition) {
    t4 = {
      label: labels.position,
      value: translatedPosition
    };
    $[6] = labels.position;
    $[7] = translatedPosition;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = age ?? undefined;
  let t6;
  if ($[9] !== labels.age || $[10] !== t5) {
    t6 = {
      label: labels.age,
      value: t5
    };
    $[9] = labels.age;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = player.country?.name || playerInfo?.nationality;
  let t8;
  if ($[12] !== labels.nationality || $[13] !== t7) {
    t8 = {
      label: labels.nationality,
      value: t7
    };
    $[12] = labels.nationality;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = currentTeam?.name;
  let t10;
  if ($[15] !== labels.team || $[16] !== t9) {
    t10 = {
      label: labels.team,
      value: t9
    };
    $[15] = labels.team;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = player.shirtNumber || playerInfo?.shirtNumber;
  let t12;
  if ($[18] !== labels.shirtNumber || $[19] !== t11) {
    t12 = {
      label: labels.shirtNumber,
      value: t11
    };
    $[18] = labels.shirtNumber;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = player.profile?.height ? `${player.profile.height} cm` : playerInfo?.height ? `${playerInfo.height} cm` : undefined;
  let t14;
  if ($[21] !== labels.height || $[22] !== t13) {
    t14 = {
      label: labels.height,
      value: t13
    };
    $[21] = labels.height;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const t15 = player.profile?.weight ? `${player.profile.weight} kg` : playerInfo?.weight ? `${playerInfo.weight} kg` : undefined;
  let t16;
  if ($[24] !== labels.weight || $[25] !== t15) {
    t16 = {
      label: labels.weight,
      value: t15
    };
    $[24] = labels.weight;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  const t17 = playerInfo?.preferredFoot;
  let t18;
  if ($[27] !== labels.preferredFoot || $[28] !== t17) {
    t18 = {
      label: labels.preferredFoot,
      value: t17
    };
    $[27] = labels.preferredFoot;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t10 || $[31] !== t12 || $[32] !== t14 || $[33] !== t16 || $[34] !== t18 || $[35] !== t4 || $[36] !== t6 || $[37] !== t8) {
    t19 = [t4, t6, t8, t10, t12, t14, t16, t18].filter(_temp2);
    $[30] = t10;
    $[31] = t12;
    $[32] = t14;
    $[33] = t16;
    $[34] = t18;
    $[35] = t4;
    $[36] = t6;
    $[37] = t8;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const infoItems = t19;
  if (infoItems.length === 0) {
    return null;
  }
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      typography: {
        name: "text-sm uppercase font-semibold text-foreground"
      }
    };
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== labels.title) {
    t21 = {
      name: labels.title,
      styles: t20
    };
    $[40] = labels.title;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      container: "mb-2"
    };
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t21) {
    t23 = <SectionHeader entity={t21} styles={t22} />;
    $[43] = t21;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== infoItems) {
    t24 = <div className="bg-card rounded-lg shadow-md p-4"><div className="grid grid-cols-2 sm:grid-cols-4 gap-4">{infoItems.map(_temp3)}</div></div>;
    $[45] = infoItems;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t23 || $[48] !== t24) {
    t25 = <div>{t23}{t24}</div>;
    $[47] = t23;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  return t25;
};
function _temp(t) {
  return t.type === "club";
}
function _temp2(item) {
  return item.value !== undefined && item.value !== null && item.value !== "";
}
function _temp3(item_0) {
  return <div key={item_0.label} className="text-center"><p className="text-xs text-muted-foreground uppercase">{item_0.label}</p><p className="text-sm font-semibold text-foreground mt-1">{item_0.value}</p></div>;
}